import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DocumentTypes } from 'src/app/definitions/document-types';
import { EditBundleItemsPage } from 'src/app/modals/edit-bundle-items/edit-bundle-items.page';
import { ProductSelectPage } from 'src/app/modals/product-select/product-select.page';
import { DetaillineDTOModel } from 'src/app/models/detaillineDTO.model';
import { DocumentModel } from 'src/app/models/document.model';

@Component({
  selector: 'customer-repair-items',
  templateUrl: './customer-repair-items.component.html',
  styleUrls: ['./customer-repair-items.component.scss'],
})
export class CustomerRepairItemsComponent implements OnInit {
  @Input() document: DocumentModel;
  @Input() addAccessories: boolean;
  detailLine = new DetaillineDTOModel();


  constructor(private modalController: ModalController,
    public docTypes: DocumentTypes,
  ) { }

  ngOnInit() {


  }

  async addRepairItem() {
    console.log("Document in customer repair items");
    console.log(this.document);
    const modal = await this.modalController.create({
        component: ProductSelectPage,
        cssClass: 'modal-fullscreen',
        componentProps: {
            'detailLine': this.detailLine,
            //'detailsArr': this.detailsArr,
            'document': this.document,
            'customerRepair': true
        }
    });

    modal.onDidDismiss().then((dataReturned) => {
        if (dataReturned.data) {
            console.log(dataReturned.data);

            this.document.serviceJob.servicedItem = dataReturned.data;
            var customerRepairItem = JSON.parse(JSON.stringify(dataReturned.data)); 

            if (!customerRepairItem.plantOrProductId) {
              customerRepairItem.plantOrProductId = customerRepairItem.id;
            }

            //if (!this.document.serviceJob.servicedItem.plantOrProductId) {
             //   this.document.serviceJob.servicedItem.plantOrProductId = this.document.serviceJob.servicedItem.id;
           // }
            

            //this.populateTasks.populateTasks(this.document.serviceJob.servicedItem.pdesc, this.document.serviceJob.jobTypeId);
            if( this.addAccessories ){
                this.document.serviceJob.bundleItems = [];
                this.handleAddAccessories(customerRepairItem);
            }

            this.document.serviceJob.customerRepairItems.push(customerRepairItem);
        }
    });
    return await modal.present();
}

cancelModal() {
    this.modalController.dismiss();
}

async handleAddAccessories(customerRepairItem: DetaillineDTOModel){
  const modal = await this.modalController.create({
      component: EditBundleItemsPage,
      cssClass: 'modal-fullscreen',
      backdropDismiss: false,
      componentProps: {
          document: this.document
      }
  });

  modal.onDidDismiss().then((dataReturned) => {
     customerRepairItem.bundleItems = JSON.parse(JSON.stringify(this.document.serviceJob.bundleItems)); 
  });
  return await modal.present();
}

removeCustomerRepairItem(indx: number){
  console.log( "removing index " + indx);
   this.document.serviceJob.customerRepairItems.splice( indx,1 );
}

}
